module.exports = __webpack_public_path__ + "static/img/img13.1bd9330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img13.png
// module id = Ul32
// module chunks = 1